import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import withRoleAccess from '../../hoc/withRoleAccess';
import { useTranslation } from 'react-i18next';
import { 
  Button, 
  Popover,
  Input, 
  Table, 
  Modal, 
  message, 
  Spin, 
  Tag, 
  Space, 
  Form, 
  Select, 
  InputNumber,
  Divider,
  Card,
  Tooltip,
  Typography,
  Alert
} from 'antd';
import { 
  DeleteOutlined, 
  EditOutlined, 
  ExclamationCircleOutlined,
  ScheduleOutlined,
  BookOutlined,
  UserOutlined,
  DollarOutlined,
  LaptopOutlined,
  ClockCircleOutlined,
  ReloadOutlined,
  EyeOutlined
} from '@ant-design/icons';
import ScheduleCalendarModal from './ScheduleCalendarModal'; 
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import ScheduleModal from './ScheduleModal';
import './Classes.css';
import moment from 'moment';
import { jwtDecode } from "jwt-decode";

const { confirm } = Modal;
const { Option } = Select;
const { Text } = Typography;

// Filters + page survive opening a course and coming back
const FILTERS_STORAGE_KEY = 'filterTaskTable.state';
const DEFAULT_FILTERS = {
  classCode: '',
  startDateRange: { start: '', end: '' },
  platform: '',
  classType: '',
  branchId: '',
  hourMismatch: false,
  onlyUnregistered: false,
  remainingHours: ''
};
const loadSavedState = () => {
  try {
    return JSON.parse(sessionStorage.getItem(FILTERS_STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

const FilterTaskTable = () => {
  const { t } = useTranslation();
  const [classGroups, setClassGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setError] = useState(null);
  const [popupData, setPopupData] = useState(null);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editData, setEditData] = useState(null);
  const [registrationsCount, setRegistrationsCount] = useState([]);
  const [currentPage, setCurrentPage] = useState(() => loadSavedState().currentPage || 1);
  const [showCalendarModal, setShowCalendarModal] = useState(false);
  const [noteModalVisible, setNoteModalVisible] = useState(false);
const [selectedNote, setSelectedNote] = useState('');
const [calendarData, setCalendarData] = useState(null);
const [branches, setBranches] = useState([]);
const [selectedStudent, setSelectedStudent] = useState(null);
const [filters, setFilters] = useState(() => ({ ...DEFAULT_FILTERS, ...loadSavedState().filters }));

useEffect(() => {
  try {
    sessionStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify({ filters, currentPage }));
  } catch {}
}, [filters, currentPage]);
  const [form] = Form.useForm();
       const token = localStorage.getItem("token");
        let userRole = null;
        let userBranchId = null;
      
        if (token) {
          try {
            const decoded = jwtDecode(token);
            userRole = decoded.role;
            userBranchId = decoded.branch_id || decoded.branchId || null; 
          } catch (err) {
            console.error("Invalid token", err);
          }
        }

  
  const itemsPerPage = 35;
  const API_URL = process.env.REACT_APP_API_URL;

  // Your existing utility functions...
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return 'Invalid Date';
  
    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).format(date);
  };
  
  const formatMinutesToHours = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}:${remainingMinutes.toString().padStart(2, '0')} ${t('hrs')}`;
  };

const processClassGroups = (data) => {
  const groupedData = data.reduce((acc, item) => {
    const existing = acc.find((entry) => entry.groupid === item.groupid);

    if (existing) {
      existing.price = existing.price || item.price;
      existing.classgroup_ids = existing.classgroup_ids || item.classgroup_id;
    } else {
      const courseHour = parseInt(item.course_hour, 10) || 0;
      const totalHours = parseInt(item.total_hours, 10) || 0;
      const presentMinutes = parseInt(item.present_minutes, 10) || 0;
      const absentMinutes = parseInt(item.absent_minutes, 10) || 0;
      const lateMinutes = parseInt(item.late_minutes, 10) || 0;
      const toBeRescheduledMinutes = parseInt(item.to_be_rescheduled_minutes, 10) || 0;

      // Remaining = credit hours minus (Present + Absent) — both consume credit
      const remainingMinutes = courseHour - (presentMinutes + absentMinutes);

      acc.push({
        ...item,

        // UI formatted version
        course_hour_formatted: formatMinutesToHours(courseHour),

        // Keep raw numbers
        course_hour_raw: courseHour,
        total_hours_raw: totalHours,
        total_hours_formatted: formatMinutesToHours(totalHours),

        // Actual hours net of to-be-rescheduled hours
        actual_hours_raw: Math.max(0, totalHours - toBeRescheduledMinutes),
        actual_hours_formatted: formatMinutesToHours(Math.max(0, totalHours - toBeRescheduledMinutes)),

        // Attendance hours (raw + formatted)
        present_minutes_raw: presentMinutes,
        absent_minutes_raw: absentMinutes,
        late_minutes_raw: lateMinutes,
        to_be_rescheduled_minutes_raw: toBeRescheduledMinutes,
        present_minutes_formatted: formatMinutesToHours(presentMinutes),
        absent_minutes_formatted: formatMinutesToHours(absentMinutes),
        to_be_rescheduled_minutes_formatted: formatMinutesToHours(toBeRescheduledMinutes),

        // Remaining hours
        remaining_hours_raw: remainingMinutes,
        remaining_hours_formatted: formatMinutesToHours(Math.abs(remainingMinutes)),

        // mismatch flag (course hours vs actual hours as displayed)
        hours_mismatch: courseHour !== Math.max(0, totalHours - toBeRescheduledMinutes),

        classgroup_ids: item.classgroup_id,
      });
    }

    return acc;
  }, []);

  return groupedData;
};


  useEffect(() => {
  const fetchBranches = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_URL}/branch`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBranches(res.data);
    } catch (err) {
      console.error("Failed to fetch branches", err);
    }
  };

  if (userRole === "superadmin" || userRole === "admin") {
    fetchBranches();
  }
}, [userRole]);

  
const fetchClassGroups = useCallback(async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/class-groups/summary`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const processedData = processClassGroups(response.data);

    setClassGroups(processedData);
    setLoading(false);
  } catch (error) {
    console.error('❌ Error fetching class groups:', error);
    console.error('📄 Error response:', error.response?.data);
    console.error('🔢 Error status:', error.response?.status);
    setError(t('fetchClassGroupsError'));
    setLoading(false);
  }
}, [API_URL, t]);



  
  const fetchRegistrationsCount = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/registrations/registrations-count`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setRegistrationsCount(response.data);
    } catch (error) {
      console.error('Error fetching registrations count:', error);
      setError(t('fetchRegistrationsCountError'));
    }
  }, [API_URL, t]);

  useEffect(() => {
    fetchClassGroups();
    fetchRegistrationsCount();
  }, [fetchClassGroups, fetchRegistrationsCount]);

  // Action handlers
  const confirmDeleteClassGroup = (groupID) => {
    confirm({
      title: t('Confirm Delete Class Group'),
      icon: <ExclamationCircleOutlined />,
      content: t('Are you sure you want to delete this course? This action is irreversible and will permanently remove all related data.'),
      okText: t('yes'),
      okType: 'danger',
      cancelText: t('no'),
      onOk() {
        handleDeleteClassGroup(groupID);
      },
      onCancel() {
      },
    });
  };

  const handleDeleteClassGroup = async (groupID) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/class-groups/${groupID}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setClassGroups((prevClasses) => prevClasses.filter((cls) => cls.groupid !== groupID));
      message.success(t('classGroupDeleted'));
    } catch (error) {
      console.error('Error deleting class group:', error);
      message.error(t('deleteClassGroupError'));
    }
  };


const handleEditClick = (classGroup) => {
  const registrationCount = getRegisteredStudents(classGroup.groupid);

  const rawMinutes = classGroup.course_hour_raw || 0;
  const courseHourHours = Math.floor(rawMinutes / 60);
  const courseHourMinutes = rawMinutes % 60;

  const formData = {
    groupID: classGroup.groupid,
    class_code: classGroup.class_code,
    book_details_materials: classGroup.book_details_materials,
    isprivate: classGroup.isprivate.toString(),
    register_capacity: classGroup.register_capacity,
    price: classGroup.price,
    platform: classGroup.platform,
    hasRegistrations: registrationCount > 0,

    // NEW
    course_hour_hours: courseHourHours,
    course_hour_minutes: courseHourMinutes,
  };

  form.setFieldsValue(formData);
  setEditData(formData);
  setEditModalVisible(true);
};

  const handleSaveEdit = async () => {
    try {
      const values = await form.validateFields();
      const token = localStorage.getItem('token');
      
      const dataToSubmit = {
        ...values,
        isprivate: values.isprivate === 'true',
        groupID: editData.groupID,
      };
      
      await axios.put(`${API_URL}/class-groups/${editData.groupID}`, dataToSubmit, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      setEditModalVisible(false);
      fetchClassGroups();
      fetchRegistrationsCount();
      message.success(t('classGroupUpdated'));
    } catch (error) {
      console.error('Error updating class group:', error);
      message.error(t('updateClassGroupError'));
    }
  };
  
  // Function to get the number of registered students for a class group
  const getRegisteredStudents = (groupId) => {
    const group = registrationsCount.find((rc) => rc.groupid === groupId);
    return group ? group.registered_students : 0;
  };

  const formatNumber = (number) => {
    if (!number) return "0.00";
    return parseFloat(number).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

const filteredClassGroups = classGroups.filter((group) => {
  const matchesClassCode = group.class_code?.toLowerCase().includes(filters.classCode.toLowerCase());

  const matchesBranch = !filters.branchId || String(group.branch_id) === String(filters.branchId);

  let matchesDateRange = true;
  if (filters.startDateRange.start || filters.startDateRange.end) {
    const groupStartDate = moment(group.start_date);
    if (filters.startDateRange.start) {
      const filterStartDate = moment(filters.startDateRange.start);
      if (groupStartDate.isBefore(filterStartDate, 'day')) matchesDateRange = false;
    }
    if (filters.startDateRange.end) {
      const filterEndDate = moment(filters.startDateRange.end);
      if (groupStartDate.isAfter(filterEndDate, 'day')) matchesDateRange = false;
    }
  }

  const matchesPlatform = !filters.platform || group.platform === filters.platform;

  const matchesClassType =
    !filters.classType ||
    (filters.classType === 'private' && group.isprivate) ||
    (filters.classType === 'group' && !group.isprivate);

  const matchesHourMismatch =
    !filters.hourMismatch || group.course_hour_raw !== group.total_hours_raw;

  const matchesUnregistered =
    !filters.onlyUnregistered || getRegisteredStudents(group.groupid) === 0;

  const matchesRemainingHours =
    !filters.remainingHours ||
    (filters.remainingHours === 'zero' && group.remaining_hours_raw === 0) ||
    (filters.remainingHours === 'positive' && group.remaining_hours_raw > 0);

  return (
    matchesClassCode &&
    matchesBranch &&
    matchesDateRange &&
    matchesPlatform &&
    matchesClassType &&
    matchesHourMismatch &&
    matchesUnregistered &&
    matchesRemainingHours
  );
});



const handleFilterChange = (key, value) => {
  setFilters(prev => ({ ...prev, [key]: value }));
};

const clearFilters = () => {
  setFilters(DEFAULT_FILTERS);
};

  const handleRefresh = () => {
  fetchClassGroups();
  fetchRegistrationsCount();
};

  const branchColors = {
  1: "blue",
  2: "green",
  3: "magenta", 
};

  const columns = [
      {
    title: t('branch'),
    dataIndex: 'branch_id',
    key: 'branch_id',
    render: (branchId, record) => {
      const color = branchColors[branchId] || "default";
      return record.name ? (
        <Tag color={color}>{record.name}</Tag>
      ) : (
        <Tag>-</Tag>
      );
    },
  },
   {
  title: t('classCode'),
  dataIndex: 'class_code',
  key: 'class_code',
  width: 200, // optional but recommended
  render: (text, record) => (
    <Link
      to={`/classdetails/${record.groupid}`}
      style={{
        fontWeight: 'bold',
        display: 'inline-block',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        maxWidth: '180px',
        lineHeight: '1.3',
      }}
    >
      {text}
    </Link>
  ),
},

 {
  title: t('schedule'),
  key: 'schedule',
  render: (_, record) => (
    <Link to={`/course/${record.groupid}`}>
      <Button 
        icon={<ScheduleOutlined />}
        type="default"
        style={{ width: '50px' }}
      >
      </Button>
    </Link>
  ),
},

    {
      title: t('startDate'),
      dataIndex: 'start_date',
      key: 'start_date',
      render: formatDate,
      sorter: (a, b) => new Date(a.start_date) - new Date(b.start_date),
      defaultSortOrder: 'descend', // or 'descend' if you want newest first or ascend if you want oldest first
    },    
    { title: t('endDate'), dataIndex: 'end_date', key: 'end_date', render: formatDate },
{
  title: t('Course Hours'),
  dataIndex: 'course_hour_formatted',
  key: 'course_hour',
  render: (text, record) => (
    <span style={{ fontWeight: record.hours_mismatch ? 'bold' : 'normal' }}>
      {text}
      {record.hours_mismatch}
    </span>
  ),
},
{
  title: t('Actual Hours'),
  dataIndex: 'actual_hours_formatted',
  key: 'actual_hours',
  render: (text, record) => (
    <Tooltip title={t('Total scheduled hours for this course')}>
      <span style={{ fontWeight: record.hours_mismatch ? 'bold' : 'normal', color: record.hours_mismatch ? '#ff4d4f' : 'inherit' }}>
        {text}
      </span>
    </Tooltip>
  ),
},
{
  title: t('present'),
  dataIndex: 'present_minutes_formatted',
  key: 'present_minutes',
  render: (text, record) => (
    <span style={{ color: record.present_minutes_raw > 0 ? '#52c41a' : '#bfbfbf', fontWeight: 500 }}>
      {text}
    </span>
  ),
},
{
  title: t('toBeRescheduled'),
  dataIndex: 'to_be_rescheduled_minutes_formatted',
  key: 'to_be_rescheduled_minutes',
  render: (text, record) => (
    <span style={{ color: record.to_be_rescheduled_minutes_raw > 0 ? '#722ed1' : '#bfbfbf', fontWeight: 500 }}>
      {text}
    </span>
  ),
},
{
  title: t('absent'),
  dataIndex: 'absent_minutes_formatted',
  key: 'absent_minutes',
  render: (text, record) => (
    <span style={{ color: record.absent_minutes_raw > 0 ? '#ff4d4f' : '#bfbfbf', fontWeight: 500 }}>
      {text}
    </span>
  ),
},
{
  title: t('Remaining Hours'),
  dataIndex: 'remaining_hours_formatted',
  key: 'remaining_hours',
  onCell: (record) => (
    record.remaining_hours_raw === 0
      ? { style: { backgroundColor: '#fff1f0' } }
      : {}
  ),
  render: (text, record) => {
    const isNegative = record.remaining_hours_raw < 0;
    const isZero = record.remaining_hours_raw === 0;
    return (
      <Tooltip title={t('Course Hours minus (Present + Absent)')}>
        <span style={{ color: isNegative || isZero ? 'red' : 'green', fontWeight: 'normal' }}>
          {isNegative ? `- ${text}` : `+ ${text}`}
        </span>
      </Tooltip>
    );
  },
},


    {
      title: t('private'),
      dataIndex: 'isprivate',
      key: 'isprivate',
      render: (isPrivate) => (
        <Tag color={isPrivate ? 'blue' : 'green'}>
          {isPrivate ? t('private') : t('group')}
        </Tag>
      ),
    },
    {
      title: t('Reg'),
      key: 'totalRegis',
      render: (_, record) => getRegisteredStudents(record.groupid),
    },
    {
      title: t('price'),
      key: 'price',
      render: (_, record) => {
        const hasBasePrice = record.price && record.price !== "0.00";
        const hasPackages = record.package_pricing && record.package_pricing.length > 0;
    
        return (
          <div>
            {/* Show base price if it exists and is not zero */}
            {hasBasePrice && (
              <div style={{ marginBottom: hasPackages ? '12px' : '0' }}>
                <span style={{ 
                  color: '#1890ff', // Blue color for base price
                  fontWeight: 500,
                  fontSize: '15px'
                }}>
                  {formatNumber(record.price)} {t('THB')}
                </span>
              </div>
            )}
            
            {/* Divider if both prices exist */}
            {hasBasePrice && hasPackages && (
              <div style={{
                margin: '8px 0',
                borderBottom: '1px dashed #d9d9d9',
                width: '100%'
              }} />
            )}
            
            {/* Show package pricing if available */}
            {hasPackages && (
              <ul style={{ 
                padding: 0, 
                margin: 0, 
                listStyleType: 'none',
                color: '#52c41a' // Green color for package prices
              }}>
                {record.package_pricing.map((pkg, index) => (
                  <li 
                    key={`${record.groupid}-${index}`} 
                    style={{ 
                      marginBottom: '4px',
                      fontSize: '14px'
                    }}
                  >
                    <strong style={{ color: '#262626' }}>{pkg.number_of_classes} {t('classes')}:</strong>{' '}
                    <span style={{ fontWeight: 500 }}>{formatNumber(pkg.price_per_package)} {t('THB')}</span>{' '}
                    <span style={{ color: '#8c8c8c' }}>({pkg.validity_months} {t('months')})</span>
                  </li>
                ))}
              </ul>
            )}
            
            {/* Show message if no price information is available */}
            {(!hasBasePrice && !hasPackages) && (
              <span style={{ color: '#bfbfbf', fontStyle: 'italic' }}>
                {t('noPriceAvailable')}
              </span>
            )}
          </div>
        );
      },
    },    
    {
      title: t('created_by'),
      dataIndex: 'admin_nickname',
      key: 'admin_nickname',
      render: (_, record) => (
        <div>
          <Tag color="volcano" style={{ fontSize: '11px', padding: '0 6px' }}>
            {record.admin_nickname || '-'}
          </Tag>
          <div style={{ fontSize: '12px', color: '#888' }}>
            {record.create_date ? formatDate(record.create_date) : ''}
          </div>
        </div>
      ),
    },
{
  title: t('note'),
  dataIndex: 'book_details_materials',
  key: 'book_details_materials',
  width: 100,
  align: 'center',
  render: (text) => {
    if (!text || text.trim() === '') {
      return <Text type="secondary">-</Text>;
    }
    
    return (
      <Popover
        content={
          <div style={{ 
            maxWidth: 400, 
            maxHeight: 300,
            overflowY: 'auto',
            whiteSpace: 'pre-wrap', 
            wordBreak: 'break-word' 
          }}>
            {text}
          </div>
        }
        title={t('Note Details')}
        trigger="click"
        placement="left"
      >
        <Button
          type="primary"
          size="small"
          icon={<EyeOutlined />}
        />
      </Popover>
    );
  }
},
    {
  title: t('actions'),
  key: 'actions',
  render: (_, record) => {
    const totalRegistrations = getRegisteredStudents(record.groupid);
    const hasRegistrations = totalRegistrations > 0;
    
    return (
      <Space>
        <Tooltip title={t('edit')}>
          <Button 
            type="primary"
            shape="circle"
            icon={<EditOutlined />} 
            onClick={() => handleEditClick(record)} 
            ghost
          />
        </Tooltip>
        <Tooltip title={hasRegistrations ? t('Cannot Delete With Registrations') : t('delete')}>
          <Button 
            danger
            type="primary"
            shape="circle"
            icon={<DeleteOutlined />} 
            onClick={() => hasRegistrations ? null : confirmDeleteClassGroup(record.groupid)}
            disabled={hasRegistrations}
          />
        </Tooltip>
      </Space>
    );
  }
},
  ];
  
  return (
    <div>
      <Sidebar />
      <Header />
      <div className="manage-course-container">
        <Card style={{ marginBottom: '20px' }}>
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'end' }}>
{userRole === "superadmin" && (
  <div style={{ minWidth: '200px' }}>
    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>
      {t('branch')}
    </label>
    <Select
      placeholder={t('All Branches')}
      value={filters.branchId || undefined}
      onChange={(value) => handleFilterChange('branchId', value || '')}
      allowClear
      style={{ width: '100%' }}
    >
      {branches.map((branch) => (
        <Option key={branch.id} value={branch.id}>
          {branch.name}
        </Option>
      ))}
    </Select>
  </div>
)}

    <div style={{ minWidth: '200px' }}>
      <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>
        {t('searchByClassCode')}
      </label>
      <Input
        placeholder={t('searchByClassCode')}
        value={filters.classCode}
        onChange={(e) => handleFilterChange('classCode', e.target.value)}
        prefix={<BookOutlined style={{ color: '#bfbfbf' }} />}
        allowClear
      />
    </div>

{/* Start Date Range */}
<div style={{ minWidth: '300px' }}>
  <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>
    {t('Start Date Range')}
  </label>
  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
    {/* Start Date */}
    <div style={{ position: 'relative' }}>
      {/* Hidden native date input - positioned but invisible */}
      <input
        type="date"
        value={filters.startDateRange.start}
        onChange={(e) => handleFilterChange('startDateRange', {
          ...filters.startDateRange,
          start: e.target.value
        })}
        id="hidden-start-date-filter"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '110px',
          height: '32px',
          opacity: 0,
          pointerEvents: 'none'
        }}
      />
      
      {/* Visible formatted input */}
      <input
        type="text"
        readOnly
        value={filters.startDateRange.start ? moment(filters.startDateRange.start).format('DD MMM YYYY') : ''}
        placeholder="dd mmm yyyy"
        onClick={() => document.getElementById('hidden-start-date-filter')?.showPicker()}
        style={{
          padding: '4px 8px',
          borderRadius: '6px',
          border: '1px solid #d9d9d9',
          height: '32px',
          cursor: 'pointer',
          minWidth: '110px'
        }}
      />
    </div>

    <span style={{ color: '#666' }}>to</span>

    {/* End Date */}
    <div style={{ position: 'relative' }}>
      {/* Hidden native date input - positioned but invisible */}
      <input
        type="date"
        value={filters.startDateRange.end}
        onChange={(e) => handleFilterChange('startDateRange', {
          ...filters.startDateRange,
          end: e.target.value
        })}
        id="hidden-end-date-filter"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '110px',
          height: '32px',
          opacity: 0,
          pointerEvents: 'none'
        }}
      />
      
      {/* Visible formatted input */}
      <input
        type="text"
        readOnly
        value={filters.startDateRange.end ? moment(filters.startDateRange.end).format('DD MMM YYYY') : ''}
        placeholder="dd mmm yyyy"
        onClick={() => document.getElementById('hidden-end-date-filter')?.showPicker()}
        style={{
          padding: '4px 8px',
          borderRadius: '6px',
          border: '1px solid #d9d9d9',
          height: '32px',
          cursor: 'pointer',
          minWidth: '110px'
        }}
      />
    </div>
  </div>
</div>

    {/* Class Type Filter */}
    <div style={{ minWidth: '150px' }}>
      <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>
        {t('Type')}
      </label>
      <Select
        placeholder={t('All Types')}
        value={filters.classType || undefined}
        onChange={(value) => handleFilterChange('classType', value || '')}
        allowClear
        style={{ width: '100%' }}
      >
        <Option value="private">
          <UserOutlined /> {t('private')}
        </Option>
        <Option value="group">
          <UserOutlined /> {t('group')}
        </Option>
      </Select>
    </div>
    <div style={{ minWidth: '150px' }}>
  <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>
    {t('Hour Status')}
  </label>
  <Select
    placeholder={t('All Classes')}
    value={filters.hourMismatch ? 'mismatch' : undefined}
    onChange={(value) => handleFilterChange('hourMismatch', value === 'mismatch')}
    allowClear
    style={{ width: '100%' }}
  >
    <Option value="mismatch">
      <ExclamationCircleOutlined style={{ color: '#faad14' }} /> {t('Hour Mismatch')}
    </Option>
  </Select>
</div>
<div style={{ minWidth: '150px' }}>
  <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>
    {t('Registration Status')}
  </label>
  <Select
    placeholder={t('All')}
    value={filters.onlyUnregistered ? 'unregistered' : undefined}
    onChange={(value) => handleFilterChange('onlyUnregistered', value === 'unregistered')}
    allowClear
    style={{ width: '100%' }}
  >
    <Option value="unregistered">
      0 {t('Registrations')}
    </Option>
  </Select>
</div>
<div style={{ minWidth: '150px' }}>
  <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>
    {t('Remaining Hours')}
  </label>
  <Select
    placeholder={t('All')}
    value={filters.remainingHours || undefined}
    onChange={(value) => handleFilterChange('remainingHours', value || '')}
    allowClear
    style={{ width: '100%' }}
  >
    <Option value="zero">
      <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} /> 0 {t('hrs')}
    </Option>
    <Option value="positive">
      &gt; 0 {t('hrs')}
    </Option>
  </Select>
</div>


    {/* Action Buttons */}
    <div style={{ display: 'flex', gap: '8px' }}>
      <Button onClick={clearFilters}>
        {t('Clear')}
      </Button>
      <Button type="default" onClick={handleRefresh} icon={<ReloadOutlined />}>
        {t('Refresh')}
      </Button>
    </div>
  </div>

  {/* Filter Summary */}
  <div style={{ marginTop: '12px', fontSize: '14px', color: '#666' }}>
    {t('Showing')} {filteredClassGroups.length} of {classGroups.length} {t('classes')}
  </div>
</Card>

        <Spin spinning={loading}>
        <Table
            columns={columns}
            dataSource={filteredClassGroups}
            rowKey="groupid"
            pagination={{
              current: currentPage,
              pageSize: itemsPerPage,
              total: filteredClassGroups.length, // Update total count
              onChange: (page) => setCurrentPage(page),
              showSizeChanger: false,
            }}
            scroll={{ x: 'max-content' }}
            bordered
            style={{
              overflowX: 'auto',
              width: '100%',
              maxWidth: '100%'
            }}
          />
        </Spin>

        {/* Schedule Modal */}
        <ScheduleModal isVisible={!!popupData} onClose={() => setPopupData(null)} popupData={popupData} classChangeLogs={[]} />

        <Modal
          title={<><EditOutlined /> {t('editClassGroup')}</>}
          open={editModalVisible}
          onCancel={() => setEditModalVisible(false)}
          footer={[
            <Button key="cancel" onClick={() => setEditModalVisible(false)}>
              {t('cancel')}
            </Button>,
            <Button key="submit" type="primary" onClick={handleSaveEdit}>
              {t('save')}
            </Button>
          ]}
          destroyOnClose
          maskClosable={false}
          width={600}
          centered
        >
          <Form
            form={form}
            layout="vertical"
            requiredMark={false}
          >
            <Form.Item
              name="class_code"
              label={<Space><BookOutlined />{t('classCode')}</Space>}
              rules={[
                { required: true, message: t('pleaseEnterClassCode') }
              ]}
            >
              <Input placeholder={t('enterClassCode')} />
            </Form.Item>
            {/* ---------------- COURSE HOURS ---------------- */}
            <Form.Item
              label={<Space><ClockCircleOutlined />{t('Course Hours')}</Space>}
              required
            >
              <div style={{ display: 'flex', gap: '12px' }}>
                {/* HOURS INPUT */}
                <Form.Item
                  name="course_hour_hours"
                  noStyle
                  rules={[{ required: true, message: t('pleaseEnterHours') }]}
                >
                  <InputNumber
                    min={0}
                    placeholder={t('hours')}
                    style={{ width: '100px' }}
                  />
                </Form.Item>

                {/* MINUTES INPUT */}
                <Form.Item
                  name="course_hour_minutes"
                  noStyle
                  rules={[
                    { required: true, message: t('pleaseEnterMinutes') },
                    {
                      validator(_, value) {
                        if (value >= 0 && value < 60) return Promise.resolve();
                        return Promise.reject(t('minutesMustBe0to59'));
                      }
                    }
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={59}
                    placeholder={t('minutes')}
                    style={{ width: '100px' }}
                  />
                </Form.Item>
              </div>
            </Form.Item>
            
            <Form.Item
              name="book_details_materials"
              label={<Space><BookOutlined />{t('note')}</Space>}
            >
              <Input.TextArea 
                rows={3}
                placeholder={t('Note')} 
              />
            </Form.Item>
            
            <Divider />
            
            {/* Subject Group field removed from main Edit form */}
            
            <Form.Item
              name="isprivate"
              label={<Space><UserOutlined />{t('Type')}</Space>}
              rules={[
                { required: true, message: t('pleaseSelectClassType') }
              ]}
            >
              <Select placeholder={t('selectClassType')}>
                <Option value="true">{t('private')}</Option>
                <Option value="false">{t('group')}</Option>
              </Select>
            </Form.Item>

            
            <Form.Item
              name="register_capacity"
              label={<Space><UserOutlined />{t('registerCapacity')}</Space>}
              rules={[
                { required: true, message: t('pleaseEnterCapacity') }
              ]}
            >
              <InputNumber 
                min={1} 
                placeholder={t('enterCapacity')}
                style={{ width: '100%' }}
              />
            </Form.Item>
            
            <Divider />
            
            {editData?.hasRegistrations && (
              <Alert
                type="warning"
                showIcon
                style={{ marginBottom: '16px' }}
                message={t('Changing the price only affects new registrations')}
                description={t('Students already registered, along with their existing invoices and receipts, will keep the old price.')}
              />
            )}

            <Form.Item
              name="price"
              label={<Space><DollarOutlined />{t('price')}</Space>}
              rules={[
                { required: true, message: t('pleaseEnterPrice') }
              ]}
            >
              <InputNumber
                min={0}
                step={0.01}
                precision={2}
                prefix="฿"
                style={{ width: '100%' }}
                placeholder={t('enterPrice')}
                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={value => value.replace(/\$\s?|(,*)/g, '')}
              />
            </Form.Item>

            <Form.Item hidden name="groupID">
              <Input />
            </Form.Item>
          </Form>
        </Modal>
        <ScheduleCalendarModal
            isVisible={showCalendarModal}
            onClose={() => {
              setShowCalendarModal(false);
              setCalendarData(null);
              setSelectedStudent(null);
            }}
            classGroupData={calendarData}
            classChangeLogs={[]}
            selectedStudent={selectedStudent}
          />
      </div>
    </div>
  );
};

export default withRoleAccess(FilterTaskTable, ['admin', 'superadmin']);